$('body').on('click', '.quick-add-bulk-popup-wrapper', function(e) {
    e.preventDefault();
    var cstm_url = $(this).attr('data-product-link');

    if (!cstm_url) {
        console.error('Custom URL is missing or invalid.');
        return;
    }
    $('.featured-collection-loader-wrapper').css('display', 'flex');
    $('body').addClass('quick-view-active');
$('.featured-collection-data-popup-wrapper svg.icon.icon-close').hide();
$.ajax({
    url: cstm_url,
    type: 'GET',
    dataType: 'html',
    success: function(data) {
        var productHtml = $(data).find('.product-main-wrapper');

        if (productHtml.length) {
            var productInfo = productHtml.find('product-info');
             $('.featured-collection-data-popup-wrapper').css('display', 'block');
         $('.featured-collection-data-popup').html(productHtml.html());

            $('.featured-collection-loader-wrapper').css('display', 'none');
           setTimeout(function () {
          $('.featured-collection-data-popup-wrapper svg.icon.icon-close').show();
              }, 1000);
        } else {
            console.error('Product main wrapper not found in the response.');
        }
    },
    error: function(jqXHR, textStatus, errorThrown) {
        console.error('AJAX error:', textStatus, errorThrown);
    }
});
  
     setTimeout(function() {
initVerticalThumbnailSlider();
       }, 2000);
function initVerticalThumbnailSlider() {
  if (!document.body.classList.contains('quick-view-active')) return;

  const $slider = $('.featured-collection-data-popup .thumnbnail-media-position-verticle .thumbnail-list');
  const popupWrapper = document.querySelector('.featured-collection-data-popup .thumnbnail-media-position-verticle .thumbnail-list');

  if (popupWrapper) {
    const thumbnails = popupWrapper.querySelectorAll('li');

    if (thumbnails.length > 4) {
      // Avoid re-initializing
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }

      $slider.slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 1,
        vertical: true,
        verticalSwiping: true,
        arrows: true,
        draggable: true,
        prevArrow: '<div class="slick-prev"><svg class="icon--icon-prev" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="M7 1L5.6 2.5L13 10l-7.4 7.5L7 19l9-9z"/></svg></div>',
        nextArrow: '<div class="slick-next"><svg class="icon--icon-next" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="m4 10l9 9l1.4-1.5L7 10l7.4-7.5L13 1z"/></svg></div>',
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      });

      // Force layout calculation
      setTimeout(() => {
        $slider.slick("setPosition");
      }, 100);
    }else if(thumbnails.length == 1) {
$('.featured-collection-data-popup .thumnbnail-media-position-verticle').addClass('slider-has-one-thumbnail');
    }
  }
}


});

document.body.addEventListener('click', function (event) {
    if (event.target.closest('.featured-collection-data-popup-wrapper svg.icon.icon-close')) {
  setTimeout(function() {
    document.body.classList.remove('quick-view-active');
     document.querySelector('.featured-collection-data-popup-wrapper').style.display = 'none';
    initThumbnailSlider();
}, 1000);
       
        
    }
});

document.addEventListener("click", function (event) {
    let popupWrapper = document.querySelector(".featured-collection-data-popup-wrapper");
    if (!popupWrapper || window.getComputedStyle(popupWrapper).display === "none") {
        return; 
    }

    
    if (!popupWrapper.contains(event.target)) {
        document.body.classList.remove("quick-view-active");
        popupWrapper.style.display = "none";
       initThumbnailSlider();
    } else {
       
    }
});